/*
 * This work has been created or enhanced by
 *   Markus Luckey, 2025, KERNBLICK GmbH
 *
 * This file is covered by the EU PL 1.2 license.
 * You may obtain a copy of the licence at
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 */

import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    welcome: 'Welcome to the CIVITAS/CORE Platform',
    services: 'Services',
    localCA: 'Local CA of the platform',
    downloadCACert: 'Download CA Cert',
    downloadCRL: 'Download CRL',
    downloadCRLPem: 'Download CRL PEM',
    download: 'Download',
    signingIn: 'Signing in...',
    signOut: 'Sign Out',
    signedOut: 'Signed out!',
    signingOut: 'Signing out...',
    docs: 'Documentation',
    repository: 'Repository',
    accessDenied: 'Access denied',
    returnHome: 'Click here to return to home page.',
    authTest: 'Auth Test',
    readApps: 'Read apps from apps.js',
    getApps: 'Get Apps',
    tokenInformation: 'Token Information',
    token: 'Token',
    tokenProfile: 'Token Profile',
    idToken: 'Id Token',
    sessionState: 'Session State',
    accessToken: 'Access Token',
    scopes: 'Scopes',
    forceTokenRenewal: 'Force Access Token Renewal',
    api: 'API',
    tokenInfo: 'Information of Token',
    navigate: 'Navigate',
    offline: 'Offline',
    unknown: 'Status unknown',
  },
  de: {
    welcome: 'Willkommen auf der CIVITAS/CORE Plattform',
    services: 'Dienste',
    localCA: 'Lokale CA der Plattform',
    downloadCACert: 'CA-Zertifikat herunterladen',
    downloadCRL: 'CRL herunterladen',
    downloadCRLPem: 'CRL PEM herunterladen',
    download: 'Download',
    signingIn: 'Anmeldung...',
    signOut: 'Abmelden',
    signedOut: 'Abgemeldet!',
    signingOut: 'Abmeldung...',
    docs: 'Dokumentation',
    repository: 'Repository',
    accessDenied: 'Zugriff verweigert',
    returnHome: 'Klicken Sie hier, um zur Startseite zurückzukehren.',
    authTest: 'Authentifizierungstest',
    readApps: 'Apps aus apps.js lesen',
    getApps: 'Apps abrufen',
    tokenInformation: 'Token-Informationen',
    token: 'Token',
    tokenProfile: 'Token-Profil',
    idToken: 'ID-Token',
    sessionState: 'Sitzungsstatus',
    accessToken: 'Zugriffstoken',
    scopes: 'Bereiche',
    forceTokenRenewal: 'Erzwinge Zugriffstoken-Erneuerung',
    api: 'API',
    tokenInfo: 'Informationen zum Token',
    navigate: 'Navigieren',
    offline: 'Offline',
    unknown: 'Status unbekannt',
  },
  // Add other languages here
};

const userLocale = navigator.language || navigator.userLanguage || 'de';

const i18n = createI18n({
  legacy: false,
  locale: userLocale.split('-')[0] || 'de',
  fallbackLocale: 'en',
  messages,
});

export default i18n;
